"use client";

import { useState } from "react";

export default function CompareInfo() {
    const [open, setOpen] = useState(false);

    return (
        <div className="mt-8">
            <div className={`max-w-none bg-white`}>
                <h2
                    className="text-[20px] md:text-[26px] leading-[24px] md:leading-[40px] font-semibold md:font-bold tracking-[0%] align-middle mb-2 w-full capitalize"
                    
                >
                    Compare Cars Online at MyCarJunction
                </h2>

                {/* Always-visible excerpt */}
                <p className="text-[#6B7280] mb-2">
                    Confused between multiple cars? <strong>MyCarJunction</strong> solves this with a quick and easy
                    car comparison platform in India where you can compare specifications without any technical difficulty.
                    Whether you want to compare petrol cars, electric cars, or SUVs, our system helps you understand everything
                    in a simple format.
                </p>

                {/* Hidden when collapsed: full details */}
                {open && (
                    <>

                        <h3 className="text-md md:text-lg font-bold w-full capitalize">Select Any Models You Want</h3>
                        <p className="text-[#6B7280] mb-6 py-2">
                            Start by choosing up to four cars. Once selected, our system shows important details in a clear view.
                            This includes the basics like engine type, performance, transmission, boot space, and safety features.
                            <strong>MyCarJunction</strong> also offers a smooth way to compare cars India buyers usually consider,
                            from budget friendly hatchbacks to full size SUVs.
                        </p>

                        <h3 className="text-lg font-bold w-full capitalize">Car Features Comparison Made Easy</h3>
                        <p className="text-[#6B7280] mb-4 py-2">
                            Many buyers struggle with technical terms. That’s why our layout keeps everything simple.
                            The car features comparison page shows each model’s highlights in short, meaningful points.
                            Whether it’s fuel type, comfort features, digital screens, or safety ratings, everything appears
                            in a side by side format for clarity.
                        </p>

                        <h3 className="text-lg font-bold w-full capitalize">Find the Best Mileage &amp; Performance</h3>
                        <p className="text-[#6B7280] mb-4 py-2">
                            Mileage is one of the biggest priorities for Indian buyers. So our platform includes a separate
                            mileage comparison of cars section that helps you understand which model saves more fuel in daily use.
                            You can also check power, torque, and driving feel to understand the real difference between models.
                        </p>

                        <h3 className="text-lg font-bold w-full capitalize">Transparent Car Price Comparison</h3>
                        <p className="text-[#6B7280] mb-4 py-2">
                            Buying a car is not just about features; price matters too. <strong>MyCarJunction</strong> makes car price
                            comparison simple by showing on-road prices from different regions. This helps you understand which model
                            gives better value, which variant fits your budget, and how different brands price their cars in India.
                        </p>

                        <h3 className="text-lg font-bold w-full capitalize">Compare Cars Online from Different Brands</h3>
                        <p className="text-[#6B7280] mb-4 py-2">
                            You can compare cars online from any manufacturer: Maruti, Tata, Hyundai, Mahindra, Toyota, or others.
                            The tool also supports car models comparison across trims and generations. Whether you want to compare a
                            compact SUV with a premium hatchback or old vs new versions, <strong>MyCarJunction</strong> gives accurate results.
                        </p>

                        <h3 className="text-lg font-bold w-full capitalize">Helps You Choose the Right Car Faster</h3>
                        <p className="text-[#6B7280] mb-4 py-2">
                            The full Compare Cars in India experience is designed to help all types of users. Even if you know nothing
                            about engines or specs, our car compare tool shows only the details that matter. With clear comparisons,
                            easy navigation, and accurate information, choosing the right car becomes smooth and stress free.
                        </p>
                    </>
                )}

                <div className="mt-2">
                    <button
                        onClick={() => setOpen(!open)}
                        className="inline-block border-none text-sm font-medium text-teal-600 hover:text-teal-800 focus:outline-none"
                        aria-expanded={open}
                    >
                        {open ? "Read less" : "Read more"}
                    </button>
                </div>
            </div>
        </div>
    );
}
